import React, { useId, useRef } from "react";
import useFocusTrap from "../hooks/useFocusTrap";

export default function AlertModal({
  title,
  message,
  onClose,
  confirmLabel = "OK",
  onConfirm,
  cancelLabel = "Cancel",
  showCancel = false,
}) {
  const dialogRef = useRef(null);
  const confirmRef = useRef(null);
  const titleId = useId();
  const messageId = useId();

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  useFocusTrap(true, dialogRef, confirmRef, onClose);

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-80 flex items-center justify-center z-[9999]">
      <div
        ref={dialogRef}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={messageId}
        className="relative bg-white rounded-lg shadow-lg max-w-md w-[90%] p-6"
      >
        <h2
          id={titleId}
          className="text-xl font-bold text-accent1 mb-3"
        >
          {title}
        </h2>
        <p
          id={messageId}
          className="text-accent1 mb-6 whitespace-pre-line"
        >
          {message}
        </p>
        <div className="flex justify-end gap-3">
          {showCancel && (
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-secondary-grey hover:bg-transparent-grey text-accent1 rounded kx-focus"
            >
              {cancelLabel}
            </button>
          )}
          <button
            ref={confirmRef}
            type="button"
            onClick={handleConfirm}
            className="px-4 py-2 bg-accent2 hover:bg-purple-700 text-white rounded kx-focus"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
